export default "icons-remove-image"